/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../shared/first_party_addons';
import '../data/installation_action_source';
import '../data/source_details';
import './addon_response_status';
import '../data/localized_addon';
import '../data/addon_status_for_seller';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "addons": {
        "nested": {
          "external": {
            "nested": {
              "UninstallAddonRequest": {
                "fields": {
                  "firstPartyAddon": {
                    "type": ".squareup.addons.shared.FirstPartyAddon",
                    "id": 1,
                    "rule": "optional"
                  },
                  "idempotenceKey": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "shouldDisable": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "actingEmployeeToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "actionSource": {
                    "type": ".squareup.addons.data.InstallationActionSource",
                    "id": 5,
                    "rule": "optional"
                  },
                  "populateAddonInResponse": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "sourceDetails": {
                    "type": ".squareup.addons.data.SourceDetails",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              },
              "UninstallAddonResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "localizedErrorMessage": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "addonResponseStatus": {
                    "type": ".squareup.addons.external.AddonResponseStatus",
                    "id": 3,
                    "rule": "optional"
                  },
                  "addon": {
                    "type": ".squareup.addons.data.LocalizedAddon",
                    "id": 4,
                    "rule": "optional"
                  },
                  "allAddonVerticals": {
                    "type": ".squareup.addons.data.LocalizedVertical",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "statusForSeller": {
                    "type": ".squareup.addons.data.AddonStatusForSeller",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.addons?.nested?.external?.nested?.UninstallAddonRequest && !$root.nested?.squareup?.nested?.addons?.nested?.external?.nested?.UninstallAddonResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE UninstallAddonRequest @ squareup/addons/external/uninstall_addon.proto at 16:1
 */
export const UninstallAddonRequest = $root.lookupType('squareup.addons.external.UninstallAddonRequest');
fixType(UninstallAddonRequest, {
  idempotenceKey: {
    required: true
  }
});
Builder.createAndAttachToType(UninstallAddonRequest);
/**
 * SOURCE UninstallAddonResponse @ squareup/addons/external/uninstall_addon.proto at 34:1
 */
export const UninstallAddonResponse = $root.lookupType('squareup.addons.external.UninstallAddonResponse');
fixType(UninstallAddonResponse, {
  success: {
    required: true
  }
});
Builder.createAndAttachToType(UninstallAddonResponse);